import React, { useContext, useEffect, useState } from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import { Row, Card, Spinner } from 'react-bootstrap'
import { DesignContext } from 'contexts/DesignContext'
import HeaderControl, { headerControlTester } from './Header'
import BodyControl, { bodyControlTester } from './Body'
import FooterControl, { footerControlTester } from './Footer'
import { materialRenderers, materialCells } from '@jsonforms/material-renderers'
import { JsonForms } from '@jsonforms/react'
import { Formik } from 'formik'
import { checkError } from 'designer/component/validation'
import LoadingApi from 'designer/display/loading/LoadingApi'
import objectPath from 'object-path'
import FormLoading from 'components/Loader/FormLoading'
import { isEmpty } from 'designer/component/action/condition/State'
import { handleEnterToNextInput } from 'designer/component/action/Action'

const FormControl = (props) => {
  const renderers = [
    ...materialRenderers,
    { tester: headerControlTester, renderer: HeaderControl },
    { tester: bodyControlTester, renderer: BodyControl },
    { tester: footerControlTester, renderer: FooterControl },
  ]
  const { config, schema, uischema } = props
  const { isOpenModal, isDetailPanel } = config

  const designContext = useContext(DesignContext)
  const { jsonForm, isUiChanged, setIsUiChanged } = designContext

  const initialValues = {}
  const validate = (values) => {
    let errors = checkError(jsonForm, values)
    return errors
  }

  const showHeader = isOpenModal || isDetailPanel

  let hasStartCallAPI = objectPath.has(isUiChanged, [
    'isStartCallAPI',
    uischema.key,
  ])
  let isStartCallAPI = objectPath.get(isUiChanged, [
    'isStartCallAPI',
    uischema.key,
  ])
  let callAPI = objectPath.get(isUiChanged, ['callAPI'])
  let isLoadingCallAPI = !isEmpty(callAPI)

  const [isShowLoad, setIsShowLoad] = useState(false)
  const [isShowUi, setIsShowUi] = useState(false)

  const clearLoadCall = () => {
    objectPath.del(isUiChanged, ['isStartCallAPI'])
    objectPath.del(isUiChanged, ['callAPI'])
    setIsUiChanged(isUiChanged)
    setIsShowLoad(false)
  }

  useEffect(() => {
    if (!hasStartCallAPI) return
    if (isStartCallAPI) {
      if (!isShowLoad) {
        setIsShowLoad(true)
      }
      if (isEmpty(callAPI)) {
        clearLoadCall()
      }
    } else {
      clearLoadCall()
    }
  }, [JSON.stringify(callAPI)])

  useEffect(() => {
    setIsShowUi(!isShowLoad)
  }, [isShowLoad])

  return (
    <Card
      className={`${!uischema.cardColor && `border-${uischema.variant}`}`}
      style={{
        border: !showHeader && `1px solid ${uischema.cardColor}`,
        margin: 0,
        boxShadow: !showHeader && uischema.isShowBoxShadow ? '' : 'unset',
      }}
    >
      <LoadingApi />
      {!showHeader && uischema.isShowTitle && (
        <Card.Header
          className={`${!uischema.cardColor && `bg-${uischema.variant}`}`}
          style={{ backgroundColor: uischema.cardColor }}
        >
          <div className="d-flex align-items-center">
            <Card.Title className="m-0" style={{ color: uischema.textColor }}>
              {uischema.title}
            </Card.Title>
            {isLoadingCallAPI && (
              <span
                className="ml-2 d-flex align-items-center"
                style={{
                  color: uischema.textColor,
                  fontSize: '14px',
                  fontWeight: 400,
                }}
              >
                <Spinner
                  animation="border"
                  size="sm"
                  className="mr-1"
                  style={{ width: '12px', height: '12px' }}
                />
                กำลังโหลดข้อมูล..
              </span>
            )}
          </div>
        </Card.Header>
      )}
      <Card.Body className="py-2 px-0">
        <div
          style={{
            display: !isShowLoad ? 'none' : 'block',
          }}
        >
          <FormLoading />
        </div>
        <Formik initialValues={initialValues} validate={validate}>
          {() => (
            <form
              onSubmit={(e) => e.preventDefault()}
              onKeyDown={(ev) => handleEnterToNextInput(ev, config)}
            >
              <div
                style={{
                  display: isShowLoad ? 'none' : 'block',
                  opacity: isShowUi ? 100 : 0,
                  transition: 'opacity .5s ease-in-out',
                }}
              >
                <JsonForms
                  schema={schema}
                  uischema={uischema}
                  config={{
                    ...config,
                    droppableId: uischema.key,
                  }}
                  renderers={renderers}
                  cells={materialCells}
                />
              </div>
            </form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  )
}

export const formControlTester = rankWith(3, scopeEndsWith('layout'))

export default withJsonFormsControlProps(FormControl)
